// Product name, from web/.env (VITE_APP_NAME). Walks recorded by the Android app are labelled
// with it too, since that app carries the same name.
export const APP_NAME = import.meta.env.VITE_APP_NAME
